import { render, staticRenderFns } from "./exportToExcel.vue?vue&type=template&id=6740e3d1&"
import script from "./exportToExcel.vue?vue&type=script&lang=js&"
export * from "./exportToExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports